module.exports = __webpack_public_path__ + "img/iPhone6_sml-94d10aa992a2f462d748a96cbe79bc0f.png";